// this file is generated by update_shopify_store_data.py at 2025-08-24 20:22:03.179978
var courses = [
    {
        "course_id": "83B81246-9488-EE11-9987-005056A725AD",
        "course_version": 2,
        "name": "ANA: Medical-Surgical Nursing Certification (MEDSURG-BC\u2122) PracticeIQ",
        "course_type": 1,
        "author_information": "",
        "description": "Prepare for the MEDSURG-BC\u2122 exam with confidence by quizzing yourself on over 200 practice questions covering essential areas:\r\n\r\nI. Assessment and Diagnosis\r\nII. Planning, Implementation, and Evaluation\r\nIII. Professional Role\r\nThe PracticeIQ allows you to tailor your study sessions to your needs, offering the flexibility to practice with the full question set or focus on specific Content Domain areas. Whether you choose to go through the PracticeIQ once or retake it as many times as you need, you can access this powerful tool anytime through the 24/7 learning portal.\r\nDeveloped and peer-reviewed by subject-matter experts with advanced education and certification in the specialty, ANA\u2019s certification prep materials ensure you are studying with the highest quality resources. Maximize your exam readiness and achieve your certification goals with the support of PracticeIQ. Start your comprehensive review today and take the next step in advancing your nursing career.",
        "learning_objectives_html": "The key learning outcomes for this activity are:\r\n<br />\r\n&nbsp;Prepare for the MEDSURG-BC&trade; exam based on the ANCC Test Content Outline effective September 10, 2024.",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C17A92DE-0BEA-E511-B707-005056B16096",
                "course_category_name": "Informatics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "The American Nurses Association is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "CNE",
            "credit_units": 21.0,
            "credit_unit_display_name": "Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];